import * as React from 'react';
import Button from '../../../../../common/components/Button';
import {
    CALCULATOR_MX,
    LOAN_APPLICATION_MX,
    LOAN_APPLICATION
} from '../../../../constants/LabelConstants';
import {TurboCashProps, TurboCashState} from '../../../../types/mx/turboCash/components';
import {pushDataLayer} from '../../../../../common/utils/GTMUtils';
import {DATA_LAYER} from '../../../../../common/constants/LabelConstants';
import PersonalDataSectionContainer from '../../../../containers/mx/turboCash/PersonalDataSectionContainer';
import WorkDataSectionContainer from '../../../../containers/mx/turboCash/WorkDataSectionContainer';
import CalculatorSectionContainer from '../../../../containers/mx/turboCash/CalculatorSectionContainer';
import ReferencesSectionContainer from '../../../../containers/mx/turboCash/ReferencesSectionContainer';
import FilesSectionContainer from '../../../../containers/mx/turboCash/FilesSectionContainer';
import * as ValidateConstant from '../../../../constants/ValidateConstant';
import {ACTIVE_KEY_1, ACTIVE_KEY_2, ACTIVE_KEY_3, ACTIVE_KEY_4, APP_WEB} from '../../../../constants/GlobalConstants';

class TurboCashView extends React.Component<TurboCashProps, TurboCashState> {

    constructor(props) {
        super(props);

        this.state = {
            showErrors: false,
            toggleAccordion: {
                activeKey1: true,
                activeKey2: false,
                activeKey3: false,
                activeKey4: false
            }
        };
        this.props.getLoanApplication();
    }

    componentDidMount() {
        setTimeout(() => {
            window.scrollTo({left: 0, top: 0, behavior: 'smooth'});
            pushDataLayer(DATA_LAYER.QUOTE_TURBO_CASH);
        }, 200);
    }

    toggleAccordion = (activeKey, defaultValue = false) => {
        this.setState({
            toggleAccordion: {
                [activeKey]: defaultValue ? defaultValue : !this.state.toggleAccordion[activeKey]
            }
        });
        setTimeout(() => {
            window.document.getElementById(activeKey).scrollIntoView();
        }, 300);
    }

    hasErrorsReferencesFields = () => {
        let error;
        const {otherReferences} = this.props;
        for (let i = 0; i < 3 ; i += 1) {
            error = ValidateConstant.ERROR_REQUIRED;
            if (otherReferences[i]) {
                if (otherReferences[i].completeName && otherReferences[i].completeName.length > 0 &&
                    otherReferences[i].cellphone && otherReferences[i].cellphone.length === 10 &&
                    otherReferences[i].phone && otherReferences[i].phone.length === 10 &&
                    otherReferences[i].address && otherReferences[i].address.length > 0 &&
                    otherReferences[i].extNumber && otherReferences[i].extNumber.length > 0 &&
                    otherReferences[i].postalCode && otherReferences[i].postalCode.length > 0 &&
                    otherReferences[i].state && otherReferences[i].state.value.length > 0 &&
                    otherReferences[i].municipality && otherReferences[i].municipality.value.length > 0 &&
                    otherReferences[i].selectedColony && otherReferences[i].selectedColony.value.length > 0) {
                    error = null;
                } else {
                    error = ValidateConstant.ERROR_REQUIRED;
                    break;
                }
            }
        }
        return error;
    }

    validateFields = () => {
        const validatePersonalData =
            this.props.civilStatusFieldError == null &&
            this.props.regimeFieldError == null &&
            this.props.rolHomeFieldError == null &&
            this.props.studiesFieldError == null &&
            this.props.amountDependentsFieldError == null &&
            this.props.cURPFieldError == null &&
            this.props.houseTypeFieldError == null;
        const validateWorkData = this.props.workplaceNameFieldError == null &&
            this.props.positionFieldError == null &&
            this.props.workingSinceFieldError == null &&
            this.props.employmentRotationFieldError == null &&
            this.props.addressFieldError == null &&
            this.props.extNumberFieldError == null &&
            this.props.streetBetweenFieldError == null &&
            this.props.workplacePhoneFieldError == null &&
            this.props.workplacePhoneExtError == null &&
            this.props.monthlyIncomesFieldError == null &&
            this.props.postalCodeFieldError == null &&
            this.props.stateFieldError == null &&
            this.props.cityFieldError == null &&
            this.props.municipalityFieldError == null &&
            this.props.selectedColonyFieldError == null;
        const validateReferences = this.hasErrorsReferencesFields() == null;
        !validatePersonalData && this.toggleAccordion(ACTIVE_KEY_1, true);
        validatePersonalData && !validateWorkData && this.toggleAccordion(ACTIVE_KEY_2, true);
        validatePersonalData && validateWorkData && !validateReferences && this.toggleAccordion(ACTIVE_KEY_3, true);
        return validatePersonalData && validateWorkData && validateReferences;
    }

    onSaveChanges = () => {
        if (this.validateFields()) {
            this.setState({
                showErrors: false
            }, () => {
                this.props.onSaveChanges();
            });
        } else {
            this.setState({
                showErrors: true
            });
        }
    }

    render() {
        const {
            landing, app
        } = this.props;
        const {toggleAccordion: {activeKey1, activeKey2, activeKey3, activeKey4}} = this.state;
        return (
            <div className={`container ${landing && app === APP_WEB ? 'wizard-landing landing-turbo-cash' : ''}`}>
                {app === APP_WEB &&
                    <h3 className="text-raleway text-secondary-lighten-1">¡Tu crédito ha sido pre aprobado!</h3>}
                {app === APP_WEB &&
                    <span className="regular-text sub-title">Completa el siguiente formulario para continuar</span>}
                <div className="row">
                    <div className="col side-form">
                        <CalculatorSectionContainer showErrors={this.state.showErrors} />

                        <div className="row mt-4">
                            <div className="col">
                                <div className="accordion">
                                    <div className={`accordion-item ${activeKey1 ? 'active' : ''}`}>
                                        <div className="accordion-head"
                                             onClick={() => this.toggleAccordion(ACTIVE_KEY_1)}
                                             id={ACTIVE_KEY_1}>
                                            <h2>{LOAN_APPLICATION.APPLICANT_DATA}</h2>
                                        </div>
                                        <div className="accordion-content">
                                            <PersonalDataSectionContainer showErrors={this.state.showErrors}/>
                                        </div>
                                    </div>
                                    <div className={`accordion-item ${activeKey2 ? 'active' : ''}`}>
                                        <div className="accordion-head"
                                             onClick={() => this.toggleAccordion(ACTIVE_KEY_2)}
                                             id={ACTIVE_KEY_2}>
                                            <h2>{LOAN_APPLICATION_MX.WORK_INFO}</h2>
                                        </div>
                                        <div className="accordion-content">
                                            <WorkDataSectionContainer showErrors={this.state.showErrors}/>
                                        </div>
                                    </div>
                                    <div className={`accordion-item ${activeKey3 ? 'active' : ''}`}>
                                        <div className="accordion-head"
                                             onClick={() => this.toggleAccordion(ACTIVE_KEY_3)}
                                             id={ACTIVE_KEY_3}>
                                            <h2>{LOAN_APPLICATION_MX.REFERENCES}</h2>
                                        </div>
                                        <div className="accordion-content">
                                            <ReferencesSectionContainer  showErrors={this.state.showErrors}/>
                                        </div>
                                    </div>
                                    <div className={`accordion-item ${activeKey4 ? 'active' : ''}`}>
                                        <div className="accordion-head"
                                             onClick={() => this.toggleAccordion(ACTIVE_KEY_4)}
                                             id={ACTIVE_KEY_4}>
                                            <h2>{LOAN_APPLICATION_MX.DOCUMENTS}</h2>
                                        </div>
                                        <div className="accordion-content">
                                            <FilesSectionContainer showErrors={this.state.showErrors} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row mt-5">
                            <div className="col d-flex align-items-center justify-content-center">
                                <Button text={CALCULATOR_MX.SAVE_CHANGES}
                                        onPress={this.onSaveChanges} role="button"
                                        customClass="right px-md-5 btn-block"/>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}

export default TurboCashView;